<template>
  <div>
    <h5 class="mb-3">{{ $t('login.title') }}</h5>
    <form @submit.prevent="handleSubmit">
      <div class="mb-3">
        <label class="form-label" for="login-email">Email</label>
        <input id="login-email" class="form-control" type="email" name="email" v-model="username" />
      </div>
      <div class="mb-3">
        <label class="form-label" for="login-password">{{ $t('login.password') }}</label>
        <input
          id="login-password"
          class="form-control"
          type="password"
          name="password"
          v-model="password"
        />
      </div>
      <button class="btn btn-primary w-100">{{ $t('login.btn.name') }}</button>
      <div class="d-flex justify-content-between mt-3 small">
        <button
          type="button"
          class="btn btn-link btn-sm p-0"
          @click="switchMode('register')"
        >{{ $t('login.register') }}</button>
        <button
          type="button"
          class="btn btn-link btn-sm p-0"
          @click="switchMode('repassword')"
        >{{ $t('login.forgot.password') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  computed: {
    email() {
      return this.$store.state.auth.registration
        ? this.$store.state.auth.registration.email
        : null;
    }
  },
  methods: {
    handleSubmit() {
      if (this.username && this.password) {
        this.$store.dispatch("auth/login", {
          username: this.username,
          password: this.password
        });
      }
    },
    switchMode(mode) {
      this.$emit("changeMode", mode);
    }
  },
  created() {
    if (this.email) this.username = this.email;
  }
};
</script>